'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _imgs = require('./imgs');

var _imgs2 = _interopRequireDefault(_imgs);

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

var _dofIconfont = require('../dof-iconfont');

var _dofIconfont2 = _interopRequireDefault(_dofIconfont);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var env = weex.config.env;

var animation = weex.requireModule('animation');
var dom = weex.requireModule('dom');
exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  components: { DofIconfont: _dofIconfont2.default },
  props: {
    mode: {
      type: String,
      default: 'common'
    },
    theme: {
      type: String,
      default: 'white'
    },
    layoutDirection: {
      type: String,
      default: 'column'
    },
    buttons: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    position: {
      type: Object,
      default: function _default() {
        return {
          x: 0,
          y: 0
        };
      }
    },
    arrowPosition: {
      type: Object,
      default: function _default() {
        return {
          pos: 'top',
          x: 0,
          y: 0
        };
      }
    },
    coverColor: {
      type: String,
      default: 'rgba(0, 0, 0, 0.1)'
    },
    hasAnimation: {
      type: Boolean,
      default: true
    },
    textStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    textContent: {
      type: String,
      default: ''
    },
    innerBgColor: {
      type: String,
      default: ''
    },
    isClickCoverHide: {
      type: Boolean,
      default: true
    },
    isShowClose: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 0
    },
    elPos: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      sHeight: env.deviceHeight / env.deviceWidth * 750,
      show: false,
      showIn: false,
      imgs: _imgs2.default,
      position_: { x: 0, y: 0 }
    };
  },
  watch: {
    elPos: function elPos(val) {
      var _this = this;

      setTimeout(function () {
        _this.handleElPos(val);
      }, 100);
    },

    position: {
      handler: function handler(val) {
        if (!this.elPos) {
          this.position_ = val;
        }
      },

      immediate: true
    }
  },
  created: function created() {},

  computed: {
    coverStyle: function coverStyle() {
      return this.coverColor ? { backgroundColor: this.coverColor, opacity: this.hasAnimation || !this.showIn ? '0' : '1' } : '';
    },
    transformOrigin: function transformOrigin() {
      var _arrowPosition = this.arrowPosition,
          _arrowPosition$x = _arrowPosition.x,
          x = _arrowPosition$x === undefined ? 0 : _arrowPosition$x,
          _arrowPosition$y = _arrowPosition.y,
          y = _arrowPosition$y === undefined ? 0 : _arrowPosition$y,
          _arrowPosition$pos = _arrowPosition.pos,
          pos = _arrowPosition$pos === undefined ? 'top' : _arrowPosition$pos;

      var _origins = [];
      switch (pos) {
        case 'top':
        case 'bottom':
          _origins = [x < 0 ? 'right' : 'left', pos];
          break;
        case 'left':
        case 'right':
          _origins = [pos, y < 0 ? 'bottom' : 'top'];
          break;
      }
      return _origins.join(' ');
    },
    contentTransform: function contentTransform() {
      var _arrowPosition$pos2 = this.arrowPosition.pos,
          pos = _arrowPosition$pos2 === undefined ? 'top' : _arrowPosition$pos2;
      var _arrowPosition2 = this.arrowPosition,
          _arrowPosition2$x = _arrowPosition2.x,
          x = _arrowPosition2$x === undefined ? 0 : _arrowPosition2$x,
          _arrowPosition2$y = _arrowPosition2.y,
          y = _arrowPosition2$y === undefined ? 0 : _arrowPosition2$y;

      var _translates = ['scale(0)'];
      if (x >= 0 && x < 22) {
        x = 22;
      } else if (x < 0 && x > -22) {
        x = -22;
      }
      if (y >= 0 && y < 22) {
        y = 22;
      } else if (y < 0 && y > -22) {
        y = -22;
      }
      switch (pos) {
        case 'top':
        case 'bottom':
          _translates[1] = 'translateX(' + (x < 0 ? x - 15 : x + 15) + 'px)';
          break;
        case 'left':
        case 'right':
          _translates[1] = 'translateY(' + (y < 0 ? y - 15 : y + 15) + 'px)';
          break;
      }
      return _translates.join(' ');
    },
    contentStyle: function contentStyle() {
      var _position_ = this.position_,
          _position_$x = _position_.x,
          x = _position_$x === undefined ? 0 : _position_$x,
          _position_$y = _position_.y,
          y = _position_$y === undefined ? 0 : _position_$y;

      var style = {};
      if (!this.elPos) {
        x < 0 ? style.right = -x + 'px' : style.left = x + 'px';
        y < 0 ? style.bottom = -y + 'px' : style.top = y + 'px';
      } else {
        if (this.arrowPosition.pos === 'bottom') {
          style.left = x + 'px';
          style.top = y + 'px';
        } else {
          style.left = x + 'px';
          style.top = y + 'px';
        }
      }

      style.opacity = this.hasAnimation || !this.showIn ? '0' : '1';
      style.transform = this.hasAnimation || !this.showIn ? this.contentTransform : 'scale(1)';
      style.transformOrigin = this.transformOrigin;
      return style;
    },
    arrowStyle: function arrowStyle() {
      var _arrowPosition3 = this.arrowPosition,
          _arrowPosition3$x = _arrowPosition3.x,
          x = _arrowPosition3$x === undefined ? 0 : _arrowPosition3$x,
          _arrowPosition3$y = _arrowPosition3.y,
          y = _arrowPosition3$y === undefined ? 0 : _arrowPosition3$y;
      var _arrowPosition$pos3 = this.arrowPosition.pos,
          pos = _arrowPosition$pos3 === undefined ? 'top' : _arrowPosition$pos3;

      var style = {
        backgroundColor: this.bgColor
      };
      switch (pos) {
        case 'top':
          style.top = '6px';
        case 'bottom':
          //eslint-disable-line
          !style.top && (style.bottom = '6px');
          // style.transform = 'rotateZ(45deg) rotateY(45deg)'
          if (x >= 0 && x < 22) {
            x = 22;
          } else if (x < 0 && x > -22) {
            x = -22;
          }
          x < 0 ? style.right = -x + 'px' : style.left = x + 'px';
          break;
        case 'left':
          style.left = '6px';
        case 'right':
          //eslint-disable-line
          !style.left && (style.right = '6px');
          // style.transform = 'scaleY(0.8) rotate(45deg)'
          if (y >= 0 && y < 22) {
            y = 22;
          } else if (y < 0 && y > -22) {
            y = -22;
          }
          y < 0 ? style.bottom = -y + 'px' : style.top = y + 'px';
          break;
        default:
          break;
      }
      return style;
    },
    popoverInnerStyle: function popoverInnerStyle() {
      var layoutDirection = this.layoutDirection;

      if (layoutDirection === 'row') {
        return _extends({}, this.innerContentStyle, {
          flexDirection: 'row'
        });
      } else {
        return _extends({}, this.innerContentStyle, {
          flexDirection: 'column'
        });
      }
    },
    btnInnerStyle: function btnInnerStyle() {
      var layoutDirection = this.layoutDirection;

      if (layoutDirection === 'row') {
        return {
          borderRightWidth: '1px'
        };
      } else {
        return {
          borderBottomWidth: '1px'
        };
      }
    },
    bgColor: function bgColor() {
      if (this._isColmo && this.buttons.length) return '#313338';
      return this.innerBgColor ? this.innerBgColor : this.theme === 'dark' ? '#000' : this._isColmo ? '#43464d' : '#fff';
    },
    innerContentStyle: function innerContentStyle() {
      var style = {
        backgroundColor: this.bgColor
      };
      if (this.width) style.width = this.width + 'px';
      if (this._isColmo && this.isShowClose) style.paddingRight = '10px';
      return style;
    }
  },
  methods: {
    dofPopoverShow: function dofPopoverShow() {
      var _this2 = this;

      if (this.animationLock) {
        return;
      }
      if (this.elPos.el) this.handleElPos(this.elPos);
      this.show = true;
      if (this.hasAnimation) {
        setTimeout(function () {
          return _this2.dofPopoverAnimationShow();
        }, 40);
      } else {
        setTimeout(function () {
          return _this2.showIn = true;
        }, 40);
      }
    },

    /**
     * smooth in
     **/
    dofPopoverAnimationShow: function dofPopoverAnimationShow() {
      var _this3 = this;

      var popoverEl = this.$refs['dof-popover'];
      var coverEl = this.$refs['dof-cover'];
      if (!coverEl || !popoverEl) {
        return;
      }
      this.setAnimationLock();
      var a1End = false;
      var a2End = false;
      animation.transition(popoverEl, {
        styles: {
          opacity: 1,
          transform: 'scale(1)',
          transformOrigin: this.transformOrigin
        },
        delay: 0,
        duration: 250,
        timingFunction: 'ease-out'
      }, function (e) {
        a1End = true;
        if (a1End && a2End) {
          _this3.animationLock = false;
        }
      });

      animation.transition(coverEl, {
        styles: {
          opacity: 1
        },
        delay: 0,
        duration: 250,
        timingFunction: 'ease-in'
      }, function (e) {
        a2End = true;
        if (a1End && a2End) {
          _this3.animationLock = false;
        }
      });
    },
    dofButtonClicked: function dofButtonClicked(index, key) {
      if (this.animationLock) {
        return;
      }
      this.$emit('dofPopoverButtonClicked', { key: key, index: index });
      this.hideAction();
    },

    /**
     * 隐藏操作
     */
    hideAction: function hideAction() {
      var _this4 = this;

      if (this.animationLock) {
        return;
      }
      if (this.hasAnimation && this.show) {
        this.setAnimationLock();
        var popoverEl = this.$refs['dof-popover'];
        var coverEl = this.$refs['dof-cover'];
        if (!popoverEl || !coverEl) {
          return;
        }
        var a1End = false;
        var a2End = false;
        animation.transition(popoverEl, {
          styles: {
            opacity: 0,
            transform: this.contentTransform,
            transformOrigin: this.transformOrigin
          },
          duration: 250
        }, function () {
          a1End = true;
          if (a1End && a2End) {
            _this4.show = false;
            _this4.showIn = false;
            _this4.animationLock = false;
          }
        });
        animation.transition(coverEl, {
          styles: {
            opacity: 0
          },
          duration: 250
        }, function () {
          a2End = true;
          if (a1End && a2End) {
            _this4.show = false;
            _this4.showIn = false;
            _this4.animationLock = false;
          }
        });
      } else {
        this.show = false;
        this.showIn = false;
      }
    },

    /**
     * 设置动画锁
     */
    setAnimationLock: function setAnimationLock() {
      this.animationLock = true;
    },
    clickCover: function clickCover() {
      this.isClickCoverHide && this.hideAction();
      this.$emit('dofPopoverCoverClicked');
    },
    getPosition: function getPosition(el) {
      return new Promise(function (resolve, reject) {
        dom.getComponentRect(el, function (result) {
          var size = result.size || {};
          resolve(size);
        });
      });
    },
    handleElPos: function handleElPos(val) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (val.el) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.next = 4;
                return _this5.getPosition(val.el);

              case 4:
                res = _context.sent;

                if (_this5.arrowPosition.pos === 'top' || !_this5.arrowPosition.pos) {
                  _this5.position_ = { x: res.left - 15 + _this5.elPos.offsetX, y: res.top + res.height + _this5.elPos.offsetY };
                }
                if (_this5.arrowPosition.pos === 'bottom') {
                  _this5.position_ = { x: res.left - 15 + _this5.elPos.offsetX, y: res.top - 110 - 15 + _this5.elPos.offsetY };
                }
                if (_this5.arrowPosition.pos === 'left') {
                  _this5.position_ = { x: res.left + res.width + 10 + _this5.elPos.offsetX, y: res.top - 15 + _this5.elPos.offsetY };
                }
                if (_this5.arrowPosition.pos === 'right') {
                  _this5.position_ = { x: res.left - 285 + _this5.elPos.offsetX, y: res.top - 15 + _this5.elPos.offsetY };
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-popover2/index.vue
// module id = 369
// module chunks = 0 1